<template>
  <q-layout view="hHh lpR fFf">
    <div class="fixed" style="top: 4px; right: 4px; z-index: 2999;" v-show="showCloseButton">
      <q-btn @click="closeTrigger" flat round class="q-btn--hide-focus-helper">
        <q-icon center size="2rem" color="grey-10 m-shadow-helper" name="close" />
      </q-btn>
    </div>
    <div class="fixed" style="top: 12px; right: 12px; z-index: 2999;" v-show="showLangSelector">
      <lang-selector />
    </div>

    <q-header elevated_ class="bg-white text-secondary" v-model="showHeader">
      <portal-target name="header" :transition="headerFadeTransition">
        <!-- <div class="flex flex-center q-pa-sm">
          <router-link to="/">
            <img class="e-logo-img" alt="Loetje logo" src="~assets/logo.svg">
          </router-link>
        </div> -->
      </portal-target>
      <!-- <transition
        mode="out-in"
        enter-active-class="animated slideInLeft"
        leave-active-class=" animated slideOutLeft"
      >
        <div class="fixed" style="top: 8px; left: 0px; z-index: 2999;" v-show="showBackButton">
          <q-btn @click="backTrigger" flat round class="q-btn--hide-focus-helper">
            <q-icon center size="2.5rem" color="primary" name="keyboard_arrow_left" />
          </q-btn>
        </div>
      </transition> -->
    </q-header>

    <q-page-container>
      <transition
        mode="out-in"
        :enter-active-class="`animated ${
          ($q.platform.is.safari)
            ? 'fadeIn'
            : 'slideInRight'
          }`"
        leave-active-class="animated fadeOut"
        appear-active-class_="animated fadeIn"
        appear
      >
        <router-view />
      </transition>
    </q-page-container>

    <q-footer class="bg-white text-secondary text-center q-pb-md_">
      <portal-target name="footer" :transition="footerFadeTransition">
        <!--  -->
      </portal-target>
    </q-footer>
  </q-layout>
</template>

<script>
import { openURL } from 'quasar'
import LangSelector from 'src/components/ui/LangSelector'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'BaseLayout',
  components: {
    LangSelector
  },
  data () {
    return {
      drawer: false,
      leftDrawerOpen: this.$q.platform.is.desktop
    }
  },
  computed: {
    ...mapGetters([
      'footer',
      'prevRouteName'
    ]),
    showHeader () {
      // return this.$route.name !== 'index'
      return true
    },
    showLangSelector () {
      return false
    },
    // showLangSelector () {
    //   return !['map'].includes(this.$route.name)
    // },
    showCloseButton () {
      const isIframe = this.$q.platform.within.iframe
      return !!isIframe
    },
    showTransparentFooter () {
      return false
    },
    showBackButton () {
      let output = true
      let { name } = this.$route
      if (
        (name === 'index') ||
        !this.prevRouteName
      ) {
        output = false
      }
      return output
    },
    headerFadeTransition () {
      return {
        functional: true,
        render (h, context) {
          return h('transition', {
            props: {
              mode: 'out-in',
              'enter-active-class': 'animated fadeInDown',
              'leave-active-class': 'animated fadeOutUp'
            }
          }, context.children)
        }
      }
    },
    footerFadeTransition () {
      return {
        functional: true,
        render (h, context) {
          return h('transition', {
            props: {
              mode: 'out-in',
              'enter-active-class': 'animated slideInUp',
              'leave-active-class': 'animated fadeOutDown'
            }
          }, context.children)
        }
      }
    }
  },
  methods: {
    ...mapActions('app', [
      'toggleFooter'
    ]),
    openURL,
    closeTrigger () {
      // window.xprops.close()
      window.xprops.onManualClose()
      this.$nextTick(() => {
        this.$router.push({ name: 'index' }).catch(() => {})
      })
    }
  }
}
</script>
